import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import PreservationModel from '@/models/PreservationModel';
import store from '@/store';
import { PreservationsResponse } from '@/types/surelockResponses';
import Api from '@/store/surelockApi';
import { VALID_PRESERVATION_STATUSES } from '@/utils/constants';
import dayjs from 'dayjs';
import Vue from 'vue';

@Module({
  name: 'preservations',
  namespaced: true,
  dynamic: true,
  store,
})
export class PreservationsModule extends VuexModule {
  _values: Array<PreservationModel> = [];
  prev?: string;
  next?: string;
  filteredStatus = '';

  get filtered(): Array<PreservationModel> {
    if (!this.filteredStatus || this.filteredStatus === 'ANY') {
      return this._values;
    }
    return this._values.filter(v => v.status === this.filteredStatus);
  }

  @Mutation
  receivePreservations(data: PreservationsResponse): void {
    Vue.set(this, '_values', data.preservations.map((v, i) => {
      return {
        ...v,
        index: i,
      };
    }));
  }

  @Mutation
  filter(status: string): void {
    this.filteredStatus = status;
  }

  @Mutation
  reset(): void {
    this._values = [];
    this.prev = '';
    this.next = '';
  }

  @Action({ commit: 'receivePreservations', rawError: true })
  async getPreservations(): Promise<PreservationsResponse> {
    const data = await Api.getPreservationRecords();

    // format date
    for (let i = 0; i < data.preservations.length; i++) {
      const preservation = data.preservations[i];

      preservation.created = dayjs(preservation.created).format('MMM-DD-YYYY HH:mm');
      preservation.modified = dayjs(preservation.modified).format('MMM-DD-YYYY HH:mm');
    }
    return data;
  }

  @Action({ commit: 'filter' })
  updateStatusFilter(status: string): string {
    if (VALID_PRESERVATION_STATUSES.includes(status)) {
      return status;
    }
    return 'ANY';
  }
}

export default getModule(PreservationsModule);
